import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { HIDE_ERRORS } from '../interceptors/http-error.interceptor';
import { StorageKeys, StorageService } from './storage.service';

type SavedExchangeRate = {
  date: Date;
  exchangeRates: { [key: string]: number };
};

type ExchangeRateResponse = {
  rates: { [key: string]: number };
};

@Injectable({
  providedIn: 'root',
})
export class ExchangeRateService {
  private exchangeRates: { [key: string]: number } = {};

  constructor(
    private http: HttpClient,
    private storageService: StorageService,
  ) {}

  getExchangeRate(from: string, to: string): number {
    if (!this.exchangeRates[to] || !this.exchangeRates[from]) {
      return 1.0;
    }

    return this.exchangeRates[to] / this.exchangeRates[from];
  }

  loadCurrencyRates() {
    const exchangeRateJson = this.storageService.getItem(StorageKeys.EXCHANGE_RATE);
    if (exchangeRateJson) {
      let saved = JSON.parse(exchangeRateJson) as SavedExchangeRate;
      if (saved) {
        const diff = new Date().getTime() - new Date(saved.date).getTime();
        const oneDayInMilliseconds = 24 * 60 * 60 * 1000;

        if (diff < oneDayInMilliseconds) {
          this.exchangeRates = saved.exchangeRates;
          return;
        }
      }
    }

    const options = { context: new HttpContext().set(HIDE_ERRORS, true) };

    const url = `${environment.apiDomain}/ergonomics/exchange-rate`;
    return this.http.get<ExchangeRateResponse>(url, options).pipe(
      tap((res) => {
        this.exchangeRates = res.rates;
        const saved = { date: new Date(), exchangeRates: res.rates };
        this.storageService.setItem(StorageKeys.EXCHANGE_RATE, JSON.stringify(saved));
      }),
      catchError((res) => {
        return of({});
      }),
    );
  }
}
